import React, { useEffect, useState } from 'react';
import { Box, Card, CardActionArea, CardContent, Typography, CardMedia } from '@mui/material';
import "./App.css";

const App = () => {
  const [options, setOptions] = useState([
    {
      label: 'Nextcloud',
      path: '/nextcloud',
      image: '/assets/nextcloud.webp',
      available: true,
    },
    {
      label: 'Plex',
      path: '/plex',
      image: '/assets/plex.webp',
      available: true,
    },
    {
      label: 'Open Media Vault',
      path: '/openmediavault',
      image: '/assets/openmediavault.png',
      available: true,
    },
    {
      label: 'Proxmox',
      path: '/proxmox',
      image: '/assets/proxmox.png',
      available: true,
    },
    {
      label: 'Home Assistant',
      path: 'https://vindfjall.tplinkdns.com:8123/brunbjornen-2/0',
      image: '/assets/ha.webp',
      fullpath: true,
      available: true,
    },
    {
      label: 'Kamera entré',
      path: 'http://192.168.68.56',
      image: '/assets/reolink.png',
      fullpath: true,
      available: true,
    },
    {
      label: 'Kamera uteplats',
      path: 'http://192.168.68.55',
      image: '/assets/reolink.png',
      fullpath: true,
      available: true,
    },
  ]);

  const handleRedirect = (newPath, fullpath = false) => {
    if (!fullpath) {
      const currentUrl = window.location.origin;
      window.location.href = `${currentUrl}${newPath}`;
    } else {
      window.location.href = newPath;
    }
  };

  // useEffect(() => {
  //   const checkAvailability = async () => {
  //     const updatedOptions = await Promise.all(
  //       options.map(async (option) => {
  //         try {
  //           // Bypass SSL-related availability checks
  //           const controller = new AbortController();
  //           const timeoutId = setTimeout(() => controller.abort(), 3000); // Timeout after 3 seconds
  
  //           const response = await fetch(option.fullpath ? option.path : `${window.location.origin}${option.path}`, {
  //             mode: 'no-cors',
  //             signal: controller.signal,
  //           });
  
  //           clearTimeout(timeoutId);
  
  //           if (response.ok || response.type === 'opaque') {
  //             return { ...option, available: true };
  //           }
  //         } catch (error) {
  //           if (error.name === 'AbortError') {
  //             console.warn('Request timed out:', option.path);
  //           } else {
  //             console.warn('Error checking availability:', option.path, error);
  //           }
  //           // Assume reachable for SSL-related errors
  //           if (option.fullpath) {
  //             return { ...option, available: true }; // Allow access even if an error occurs
  //           }
  //         }
  //         return { ...option, available: false };
  //       })
  //     );
  
  //     setOptions(updatedOptions);
  //   };
  
  //   checkAvailability();
  // }, []);

  return (
    <Box
      className="App"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={4}
      sx={{
        paddingTop: 4,
        paddingBottom: 4,
        minHeight: '100vh',
      }}
    >
      <Typography
        fontWeight="bold"
        sx={{
          fontFamily: "'Gill Sans-ui', sans-serif",
          textAlign: 'center',
          paddingTop: 4,
          paddingBottom: 4,
          fontSize: { xs: '2rem', sm: '4rem', md: '6rem', xl: '8rem' },
          textShadow: '0px 0px 4px rgba(0, 0, 0, 0.3)',
          color: '#1C2E3C',
        }}
      >
        Vindfjälls Molncentral
      </Typography>

      <Box display="flex" flexWrap="wrap" justifyContent="center" gap={4} width="95%">
        {options.map((option) => (
          <Card
            key={option.path}
            onClick={() => option.available && handleRedirect(option.path, option?.fullpath)}
            sx={{
              width: { xs: '130px', sm: '160px', md: '200px', lg: '300px' },
              background: option.available
                ? 'rgba(255, 255, 255, 0.3)'
                : 'rgba(200, 200, 200, 0.3)', // Gray out unavailable options
              color: '#000',
              cursor: option.available ? 'pointer' : 'not-allowed',
              borderRadius: 3,
              boxShadow: option.available
                ? '0 4px 8px rgba(0, 0, 0, 0.4)'
                : '0 2px 4px rgba(0, 0, 0, 0.2)',
              backdropFilter: 'blur(7px)',
              overflow: 'hidden',
              '&:hover': {
                transform: option.available ? 'scale(1.03)' : 'none',
                boxShadow: option.available
                  ? '0 6px 16px rgba(0, 0, 0, 0.3)'
                  : '0 2px 4px rgba(0, 0, 0, 0.2)',
              },
            }}
          >
            <CardActionArea disabled={!option.available}>
              <CardMedia
                component="img"
                height="150"
                image={option.image}
                alt={`${option.label} logo`}
                sx={{
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  filter: option.available ? 'none' : 'grayscale(100%)',
                }}
              />
              <CardContent
                sx={{
                  textAlign: 'center',
                  padding: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  component="div"
                  fontWeight="bold"
                  sx={{
                    fontFamily: "'Roboto Slab', serif",
                    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
                    fontSize: { xs: '1rem', sm: '2rem', md: '2rem', xl: '3rem' },
                  }}
                >
                  {option.label}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default App;
